import { Component, OnDestroy, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ServiceInfoClientService } from '../files-clients/service/service-info-client.service';
import { debounceTime, distinctUntilChanged, forkJoin, Observable, of, Subject, switchMap, takeUntil, timer } from 'rxjs';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { Deptors, FilterPagination, MonthlyActivity, RequestDeptors, ResultsInvoice, ResultsTopInvoices, SummaryCompany } from '../files-clients/interface/company-client.interface';
import { DateFiltersFilesClients } from '../files-clients/interface/filters-files-clients.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalLoadingFileClientsComponent } from '../modals/modal-loading-file-clients/modal-loading-file-clients.component';
import { ActivatedRoute } from '@angular/router';
import { FactoringInvoices } from '../files-clients/interface/invoice-operation.interface';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AuthService } from '../../authentication/service/auth.service';

@Component({
  selector: 'app-dashboard-clients',
  templateUrl: './dashboard-clients.component.html',
  styleUrls: ['./dashboard-clients.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('moveDown', [
      transition(':enter', [
        style({ transform: 'translateY(-100px)' }), // Ajusta el desplazamiento inicial según sea necesario
        animate('500ms ease-out', style({ transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ transform: 'translateY(-100px)' })) // Ajusta el desplazamiento final según sea necesario
      ])
    ]),
    trigger('fadeSlideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-in', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ]
})
export class DashboardClientsComponent implements OnDestroy {
  public companyId: number;
  public selectedVal: string;
  public icons = {faCircleMinus, faCircleCheck, faCircleXmark};
  public summaries?: SummaryCompany = this.summaries;
  public monthlySummaries?: MonthlyActivity[] = this.monthlySummaries;
  //public buyInvoices$: Observable<PageResult<ResultsInvoice>>;
  public sellInvoices: PageResult<ResultsInvoice>;
  public buyInvoices: PageResult<ResultsInvoice>;
  public topSellInvoices: ResultsTopInvoices[];
  public topBuyInvoices: ResultsTopInvoices[];
  public fileClientFilter: DateFiltersFilesClients;
  public fileClientFilterForTop: DateFiltersFilesClients;
  public resultSellInvoiceFactoring: FactoringInvoices[];
  public deptors$: Observable<Deptors[]>;
  readonly menu: string[] = ['Top Ventas','Top Compras','Ventas','Compras'];
  public selectedChipIndex: number = 0;
  public value="";
  public TIME_LIMIT = 600000; // 1 minuto en milisegundos

  public booCargando = true;
  public viewInvocesDetail = "TopVentas";

  public paginationSellInvoice: FilterPagination = {
    page: 1,
    pageSize: 5,
  };

  public paginationBuyInvoice: FilterPagination = {
    page: 1,
    pageSize: 5,
  };

  public paginationInvoiceTop: FilterPagination = {
    page: 1,
    pageSize: 8,
  };

  constructor(private route: ActivatedRoute, private serviceInfo: ServiceInfoClientService, private dialog: MatDialog, private authService: AuthService) {
    this.selectedVal ='dashboard';
    const currentDate = new Date();
    const currentDateStr: string = currentDate.toISOString();
    this.fileClientFilter = {
      end: currentDateStr,
      start: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        currentDate.getDate()
      ).toISOString(),
      search: '',
    };
    this.fileClientFilterForTop = {
      end: currentDateStr,
      start: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 8,
        currentDate.getDate()
      ).toISOString(),
      search: '',
    };
  }

  ngOnDestroy(): void {
    this.closeModalLoading();
  }

  ngOnInit() {
    //this.openModalLoading();
    this.initializeSessionTimer(),
    //this.companyId = parseInt(this.authService.getItemSession("companieSelected"));
    setTimeout(() => {
      this.getAllData(parseInt(this.authService.getItemSession("companieSelected")));
    }, 300);

    setTimeout(() => {
      this.authService.watchStorageSession().subscribe((value) => {
        if (!isNaN(parseInt(value)) && parseInt(value) > 0) {
          this.value = value
          this.getAllData(parseInt(value));
        }
      });
    }, 1000);

  }

  /*ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && !changes['value'].isFirstChange()) {
      const newValue = changes['value'].currentValue;
      this.getAllData(parseInt(newValue));
    }
  }*/

  public getAllData(companyId: number): void {
    this.openModalLoading();
    this.booCargando = true;
    forkJoin([
      this.serviceInfo.summaryCompany(companyId, this.fileClientFilter),
      this.serviceInfo.invoices(companyId, this.fileClientFilter, this.paginationSellInvoice),
      this.serviceInfo.getCompanyBuyInvoices(companyId, this.fileClientFilter, this.paginationBuyInvoice),
      this.serviceInfo.topInvoices(companyId, this.fileClientFilterForTop, this.paginationInvoiceTop),
      this.serviceInfo.getCompanyTopBuyInvoices(companyId, this.fileClientFilterForTop, this.paginationInvoiceTop)
    ]).subscribe(([response1, response2, response3, response4, response5]) => {
      console.log("Termine");
      this.summaries = response1;
      this.sellInvoices = response2;
      this.buyInvoices = response3;
      this.generateTopInvocesSell(response4);
      this.generateTopInvocesBuy(response5);
      this.booCargando = false;
      this.dialog.closeAll();
    });
  }

  public openModalLoading() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = 'auto';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'transparent-dialog';
    dialogConfig.backdropClass = 'transparent-backdrop';
    this.dialog.open(ModalLoadingFileClientsComponent, dialogConfig);
  }

  public closeModalLoading() {
    this.dialog.closeAll();
    this.booCargando = false;
  }

  public getSummaries(rut: number) {
    this.serviceInfo.summaryCompany(rut, this.fileClientFilter).subscribe({
      next: (response) => {
        this.summaries = response;
      },
      error: (err) => {
        console.log("Error", err);
      }
    });
  }

  public getCompanySellInvoices(companyId: number) {
    this.serviceInfo.invoices(companyId, this.fileClientFilter, this.paginationSellInvoice).subscribe({
      next: (response) => {
        this.sellInvoices = response;
        console.log("Sell recived:", response);
      },
      error: (err) => {
        console.log("Error: ",err);
      }
    });
  }

  public getCompanyTopSellInvoices(companyId: number) {
    this.serviceInfo.topInvoices(companyId, this.fileClientFilter, this.paginationInvoiceTop).subscribe({
      next: (response) => {
        this.generateTopInvocesSell(response);
      },
      error: (err) => {
        console.log("Error: ",err);
      }
    });
  }

  public getCompanyBuyInvoices(companyId: number) {
    this.serviceInfo.getCompanyBuyInvoices(companyId, this.fileClientFilter, this.paginationBuyInvoice).subscribe({
      next:(response) => {
        this.buyInvoices = response;
      },
      error: (err) => {
        console.log("Error: ",err);
      }
    })
  }

  public getCompanyTopBuyInvoices(companyId: number) {
    this.serviceInfo.getCompanyTopBuyInvoices(companyId, this.fileClientFilter, this.paginationInvoiceTop).subscribe({
      next:(response) => {
        this.generateTopInvocesBuy(response);
      },
      error: (err) => {
        console.log("Error: ",err);
      }
    })
  }

  public generateTopInvocesSell(invocesSell?: PageResult<ResultsTopInvoices>) {
    this.topSellInvoices = invocesSell?.results
    .sort((a, b) => b.totalAmount - a.totalAmount) 
    .slice(0, 8); 
  }

  public generateTopInvocesBuy(invocesBuy?: PageResult<ResultsTopInvoices>) {
    this.topBuyInvoices = invocesBuy?.results
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .slice(0, 8);
  }

  public getDatosInvoicesFactoring(companyId: number) {
    this.serviceInfo.getSellFactoringInvoice(companyId).subscribe((result) => {
      this.resultSellInvoiceFactoring = result;
    });
    (error) => {
      console.log('Error Get DicomPerona:' + error);
    };
  }

  public receiveChangeBuyInvoicePagination(pagination: FilterPagination) {
    this.paginationBuyInvoice = {
      ...this.paginationBuyInvoice,
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    this.getCompanyBuyInvoices(this.companyId);
  }

  public onValChange(value){
    this.selectedVal = value
  }

  /**
   * Metodo que recibe los nuevos valores de los filtros
   * @param event Nuevo parametros actualizados de los filtros
  */
  public receiveUpdatedFilters(event: DateFiltersFilesClients) {
    this.fileClientFilter = {
      ...this.fileClientFilter,
      start: event.start || this.fileClientFilter.start,
      end: event.end || this.fileClientFilter.end,
      search: event.search,
      preference: event.preference,
    };
    this.getSummaries(this.companyId);
    this.getCompanySellInvoices(this.companyId);
    this.getCompanyBuyInvoices(this.companyId);
  }

    //Filtro Top 10 Deudor
  public filterTop(event: number) {
    const data: RequestDeptors = {
      id: this.companyId,
      top: event,
    };
    this.deptors$ = this.serviceInfo.debtorsFiltersCompany(data);
  }

  public selectChipMenu(index: number): void {
    if (this.selectedChipIndex !== index) {
      this.selectedChipIndex = index;
      switch (index) {
        case 0:
          this.viewTopSellInvoces();
          break;
        case 1:
          this.viewTopBuyInvoces();
          break;
        case 2:
          this.viewSellInvoces();
          break;
        case 3:
          this.viewBuyInvoces();
          break;
      }
    }
  }

  public viewTopSellInvoces() {
    this.viewInvocesDetail = "TopVentas";
  }
  
  public viewTopBuyInvoces() {
    this.viewInvocesDetail = "TopCompras";
  }

  public viewSellInvoces() {
    this.viewInvocesDetail = "Ventas";
  }

  public viewBuyInvoces() {
    this.viewInvocesDetail = "Compras";
  }

  isSelectVisible = false; // Controla la visibilidad del select
  selectedUser: any; // Almacena el usuario seleccionado

  // Alterna la visibilidad del select
  toggleSelect() {
    this.isSelectVisible = !this.isSelectVisible;
  }

  filterPageSizeSellInvoices(pages: any) {
    const { pageSize, page } = pages;
    this.paginationSellInvoice = {
      ...this.paginationSellInvoice,
      page: page,
      pageSize: pageSize,
    };

    this.getCompanySellInvoices(this.companyId);
  }

  filterPageSizeBuyInvoices(pages: any) {
    const { pageSize, page } = pages;
    this.paginationBuyInvoice = {
      ...this.paginationBuyInvoice,
      page: page,
      pageSize: pageSize,
    };

    this.getCompanyBuyInvoices(this.companyId);
  }

  public actualizarFacturas() {
    sessionStorage.setItem("timeInSession", new Date().toISOString());
    this.initializeSessionTimer();
    this.serviceInfo.updateInvocesCompany(1, this.companyId)
    .subscribe({
      next: (res) => {

      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  public initializeSessionTimer() {
    const sessionStart = sessionStorage.getItem('timeInSession');
  
    if (!sessionStart) {
      // Si no hay una hora de inicio, la establecemos ahora
      sessionStorage.setItem('timeInSession', new Date().toISOString());
    } else {
      // Si ya existe una hora de inicio, calculamos el tiempo transcurrido
      const startTime = new Date(sessionStart);
      const currentTime = new Date();
      const elapsedTime = currentTime.getTime() - startTime.getTime();
  
      if (elapsedTime >= this.TIME_LIMIT) {
        this.actualizarFacturas(); // Si el tiempo ha alcanzado o superado el límite, ejecutamos la función
      } else {
        // Si no ha alcanzado el límite, configuramos un temporizador para el tiempo restante
        setTimeout(() => {
          this.actualizarFacturas();
        }, this.TIME_LIMIT - elapsedTime);
      }
    }
  }


}
